import { LMimages, LMMediadata, ApiLMimages } from "./types";
import { LMMediaResponse } from "./types";

export const parseAPILMimages = (apiLMimages: ApiLMimages): LMimages => {
    return {
        count: apiLMimages.engineImagesCount,
        minrecommended: apiLMimages.engineImegesMinRecommended,
        maxrecommended: apiLMimages.engineImegesMaxRecommended,
        mediadata: apiLMimages.mediaData,
        informationMessages: apiLMimages.informationMessages,
        mediacategories: apiLMimages.mediaCategories
    }
}



export const parseUILMimages = (lmImages: LMimages): ApiLMimages => {
    return {
        engineImagesCount: lmImages.count,
        engineImegesMaxRecommended: lmImages.maxrecommended,
        engineImegesMinRecommended: lmImages.minrecommended,
        mediaData: lmImages.mediadata,
        informationMessages: lmImages.informationMessages,
        mediaCategories: lmImages.mediacategories
    }
}

export const parseValidationDataFromResponse = (response: LMMediaResponse): LMMediadata[] => {
    let lmValidationdata : LMMediadata[] = response.media;
    for(let i:number=0;i<lmValidationdata.length;i++)
    {
        lmValidationdata[i].validation = [];
        if(response.validation && response.validation.imagesValidation && response.validation.imagesValidation[i] && response.validation.imagesValidation[i].errorMessages && response.validation.imagesValidation[i].errorMessages.length>0)
        {
            lmValidationdata[i].validation = response.validation.imagesValidation[i].errorMessages;
        }
    }
    return lmValidationdata;
}
